<template>
  <RouterView />
</template>

<script>
import { READ } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Manage',
      breadcrumb: {
        name: 'Manage',
        route: { name: 'manage' }
      },
      sidebar: [
        {
          hidden: this.$user.cannot(READ, this.$sdk.account),
          icon: ['fal', 'briefcase'],
          route: { name: 'manage-accounts' },
          name: 'Accounts'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.profile),
          icon: ['fal', 'users'],
          route: { name: 'manage-users' },
          name: 'Users'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.asset),
          icon: ['fal', 'desktop-alt'],
          route: { name: 'manage-assets' },
          name: 'Assets'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.carrier),
          icon: ['fal', 'person-carry'],
          route: { name: 'manage-carriers' },
          name: 'Carriers'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.ratecard),
          icon: ['fal', 'credit-card-front'],
          route: { name: 'manage-ratecards' },
          name: 'Rate Cards'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.fuel),
          icon: ['fal', 'gas-pump'],
          route: { name: 'manage-fuellevies' },
          name: 'Fuel Levies'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.ratesurcharge),
          icon: ['fal', 'sack-dollar'],
          route: { name: 'manage-surcharges' },
          name: 'Surcharges'
        },
        {
          hidden: this.$user.cannot(READ, 'dictionary_zone'),
          icon: ['fal', 'object-group'],
          route: { name: 'manage-zones' },
          name: 'Zones'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.scheduledpickup),
          icon: ['fal', 'calendar-alt'],
          route: { name: 'manage-schedulepickups' },
          name: 'Scheduled Pickups'
        }
      ]
    }
  }
}
</script>
